import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CLOSE_MODAL_ACTIONS } from '../../../shared/common/enums';

@Component({
  selector: 'app-missed-hc-assignment-warning-modal',
  templateUrl: './missed-hc-assignment-warning-modal.component.html',
  styleUrls: ['./missed-hc-assignment-warning-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissedHcAssignmentWarningModalComponent {
  constructor(
    public dialogRef: MatDialogRef<MissedHcAssignmentWarningModalComponent, CLOSE_MODAL_ACTIONS>
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(CLOSE_MODAL_ACTIONS.OPEN_SRC_OVERLAY);
  }
}
